module.exports = __webpack_public_path__ + "static/media/rhenus.c2a0ded6.png";